import React, { FC } from 'react';

import Layout from '../Layout';
import Button from '../shared/buttonComponents/Button';
import { useWizard, WizardStep } from '../../contexts/WizardContext';
import { getGrade, Grade } from '../../helpers/grading';

export const Loading: FC = () => {
  const {
    changeStep,
    data
  } = useWizard();

  const DisplayedGrade: Grade = getGrade(data);

  return (
    <Layout>
      <h1>Calculating...</h1>
      <p>{Grade[DisplayedGrade]}</p>
      {DisplayedGrade <= 0
      ?
        <Button
          disabled={false}
          onClick={() => changeStep(WizardStep.SORRY)}
          title="Too Risky"
        />
        :
        <Button
          disabled={false}
          onClick={() => changeStep(WizardStep.PROPOSAL)}
          title="Approved for a proposal"
        />
      }
      <div className='proposal-page-buttons'>
      </div>
    </Layout>
  );
};